import {Button} from '@components/ui/button'
import {useTranslation} from '@/translations/i18n.tsx'
import {useState} from 'react'
import {Assignment} from '@features/assignment/types.ts'
import {SubmitToAirbnbModal} from '@features/assignment/components/submit-to-airbnb-modal'
import {PhotosUploadModalRoot} from '@features/photos-upload/components/photos-upload-modal-root'
import {usePhotosUpload} from '@features/photos-upload/store.ts'

export const UploadButtons = ({assignment}: {assignment: Assignment}) => {
    const {t} = useTranslation()
    const isPhotosUploadModalOpen = usePhotosUpload(store => store.isOpen)
    const setIsPhotosUploadModalOpen = usePhotosUpload(store => store.setIsOpen)
    const [isSubmitToAirbnbModalOpen, setIsSubmitToAirbnbModalOpen] = useState(false)

    return (
        <>
            <div className="flex w-full flex-col items-center gap-2 md:w-auto md:flex-row">
                <Button
                    variant="secondary"
                    onClick={() => setIsPhotosUploadModalOpen(true, assignment.id)}
                    className="w-full md:w-auto"
                >
                    {t('assignment:descriptions:upload_assets')}
                </Button>
                <Button
                    variant="primary"
                    onClick={() => setIsSubmitToAirbnbModalOpen(true)}
                    disabled={!assignment.can_send_to_airbnb}
                    className="w-full md:w-auto"
                >
                    {t('single_shooting:submit_to_airbnb')}
                </Button>
            </div>
            {isPhotosUploadModalOpen && (
                <PhotosUploadModalRoot
                    initialMaxFiles={assignment.medias_to_upload ?? 0}
                    openSubmitModal={() => setIsSubmitToAirbnbModalOpen(true)}
                />
            )}
            {isSubmitToAirbnbModalOpen && (
                <SubmitToAirbnbModal
                    onClose={() => setIsSubmitToAirbnbModalOpen(false)}
                    assignment={assignment}
                    setSuccessModalCb={() => setIsSubmitToAirbnbModalOpen(false)}
                />
            )}
        </>
    )
}
